import { atom } from 'recoil';

export const forcedClusteringState = atom({
  key: 'forcedClusteringState',
  default: false,
});
